<!-- While in transition... -->
<div class="overlay" *ngIf="showSpinner">
  <mat-spinner diameter="40"></mat-spinner>
</div>

<div mat-dialog class="client-inquiry-dialog">
  <h2 mat-dialog-title class="client-inquiry-banner">
    {{ config.title || "FricLowenstein Client Modal" }}
  </h2>
  <div mat-dialog-content>
    <div class="inquiry-box" [formGroup]="inquiryForm">
      <div class="form-wrapper">
        <mat-form-field appearance="fill">
          <mat-label>Subject</mat-label>
          <input matInput formControlName="subject" required />
          <mat-error *ngIf="inquiryForm.get('subject')?.hasError('required')">
            Subject is required
          </mat-error>
        </mat-form-field>
        <mat-form-field appearance="fill">
          <mat-label>Your Name</mat-label>
          <input matInput formControlName="name" required />
          <mat-error *ngIf="inquiryForm.get('name')?.hasError('required')">
            Name is required
          </mat-error>
        </mat-form-field>
        <mat-form-field appearance="fill">
          <mat-label>Phone Number</mat-label>
          <input matInput formControlName="phone" placeholder="123-456-7890" maxlength="12" />
        </mat-form-field>
        <mat-form-field appearance="fill">
          <mat-label>Email</mat-label>
          <input matInput type="email" formControlName="email">
        </mat-form-field>
        <mat-form-field appearance="fill">
          <mat-label>Message</mat-label>
          <textarea matInput rows="3" formControlName="message" required>
              </textarea>
          <mat-error *ngIf="inquiryForm.get('message')?.hasError('required')">
            Message is required
          </mat-error>
        </mat-form-field>
      </div>
    </div>
  </div>
  <div mat-dialog-actions class="actions">
    <button class="cancel-btn custom-btn btn-15" mat-raised-button (click)="onClose()">
      Cancel
    </button>
    <button class="submit-btn custom-btn btn-15" mat-raised-button (click)="submitForm()">Submit</button>
  </div>
</div>
